import { render } from "./Member.vue?vue&type=template&id=b647c750"
import script from "./Member.vue?vue&type=script&lang=ts"
export * from "./Member.vue?vue&type=script&lang=ts"
script.render = render

export default script